import { IProhibitedPeriod } from '../types/product.types';

export const isReactNativeWebView = () => typeof window !== 'undefined' && window?.ReactNativeWebView;

export const removeProductIdPrefix = (productId: string): string => {
  return productId?.replace('gid://shopify/Product/', '') || '';
};

export const isAlcoholProhibitedPeriod = (data: IProhibitedPeriod[], targetDate = new Date()): boolean => {
  return data.some((period) => {
    const start = new Date(period.startTime);
    const end = new Date(period.endTime);
    return targetDate >= start && targetDate <= end;
  });
};
